import styled from '@emotion/styled';

export const Container = styled.div`
  height: fit-content;
  max-height: 345px;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 0;
    visibility: hidden;
  }
`;
